import { Component, EventEmitter, Input, Output, SimpleChanges, ViewChild } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { Router } from '@angular/router';
import { CommonModule } from '@angular/common';
import { NgSelectModule } from '@ng-select/ng-select';
import { NgxMaskDirective } from 'ngx-mask';
import Swal from 'sweetalert2';
import { MatButtonModule } from '@angular/material/button';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatOptionModule } from '@angular/material/core';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatIconModule } from '@angular/material/icon';
import { MatInputModule } from '@angular/material/input';
import { MatRadioModule } from '@angular/material/radio';
import { MatSelectModule } from '@angular/material/select';
import { MatSlideToggleModule } from '@angular/material/slide-toggle';
import { OwlDateTimeModule, OwlNativeDateTimeModule } from '@danielmoncada/angular-datetime-picker';
import { BenefInfoComponent } from '@shared/components/benef-info/benef-info.component';
import { FileUploadComponent } from '@shared/components/file-upload/file-upload.component';
import { ScrollSearchMedocPrestaComponent } from '@shared/components/scroll-search-medoc-presta/scroll-search-medoc-presta.component';
import { PrestationInfoComponent } from '@shared/components/prestation-info/prestation-info.component';
import { SearchMdicamentProComponent } from '@shared/components/search-mdicament-pro/search-mdicament-pro.component';
import { SearchExamenLaboComponent } from '@shared/components/search-examen-labo/search-examen-labo.component';
import { RestClientService } from '@core/service/rest-client.service';
import { UtilitiesService } from '@core/service/utilities.service';
import { AuthService } from '@core';
import { ScrollSearchActeComponent } from "@shared/components/scroll-search-acte/scroll-search-acte.component";
import { SearchFormComponent } from "@shared/components/search-form/search-form.component";
import { SearchFormFullComponent } from "@shared/components/search-form-full/search-form-full.component";
import { DemandeHospitalisationComponent } from './demande-hospitalisation/demande-hospitalisation.component';
import { ListeDemandeHospitActiveComponent } from "./liste-demande-hospit-active/liste-demande-hospit-active.component";
import { HistoHospitalisationComponent } from "./histo-hospitalisation/histo-hospitalisation.component";

@Component({
  selector: 'app-main-hospitalisation',
  imports: [CommonModule, NgSelectModule, FormsModule, BenefInfoComponent,
    MatFormFieldModule,
    MatInputModule,
    MatSelectModule,
    MatOptionModule,
    FormsModule,
    ReactiveFormsModule,
    MatIconModule,
    FileUploadComponent,
    MatCheckboxModule,
    MatRadioModule,
    MatDatepickerModule,
    MatButtonModule,
    OwlDateTimeModule,
    OwlNativeDateTimeModule,
    MatSlideToggleModule,
    ScrollSearchMedocPrestaComponent,
    BenefInfoComponent,
    PrestationInfoComponent,
    SearchMdicamentProComponent,
    SearchExamenLaboComponent, ScrollSearchActeComponent, SearchFormComponent, SearchFormFullComponent, DemandeHospitalisationComponent, ListeDemandeHospitActiveComponent, HistoHospitalisationComponent],
  templateUrl: './main-hospitalisation.component.html',
  styleUrl: './main-hospitalisation.component.scss'
})
export class MainHospitalisationComponent {
selectedTab = 'tab1';
  @Output() onSendBenefItem = new EventEmitter<any>();
  @Output() onClosePrescriptionMedocModal = new EventEmitter<any>();
  @Output() onGoToTab = new EventEmitter<any>();
  @Input() matricule: any
  cancelItemSelected = false
  indiceTab: number = 1;
  showDemandeModal = false;
  @ViewChild(DemandeHospitalisationComponent) demandeComp!: DemandeHospitalisationComponent;

  @Input() refreshTriggerOrdonnance!: boolean;
  user: any;
  beneficiaireAutOselect: any;
  itemBeneficiare: any;
  constructor(
    private restClient: RestClientService,
    private router: Router,
    private authService: AuthService,
    private utilities: UtilitiesService
  ) {
    this.user = this.authService.getCurrentUser();
    console.log('connected user: ', this.user);
    this.beneficiaireAutOselect = this.authService.getActiveBeneficiaire()
  }

  ngOnChanges(changes: SimpleChanges) {
  }

  
  onSetUserInfo(event: any) {
    if (event.id) {
      this.checkHospitEligibility(event);
    } else {
      this.authService.setActiveBeneficiaire({});
      this.beneficiaireAutOselect = {};
      this.itemBeneficiare = null;
    }
  }

  private checkHospitEligibility(benef: any) {
    this.restClient.post('bareme/checkEligibilityByGarantie', {
      user_id: this.user.id,
      filiale_id: this.user.filiale_id,
      data: { matricule: benef.matricule, garantie_codification: 'HOS' },
    }).subscribe({
      next: (res: any) => {
        if (res && !res['hasError']) {
          this.itemBeneficiare = benef;
          this.authService.setActiveBeneficiaire(benef);
          this.beneficiaireAutOselect = benef;
        } else {
          this.utilities.showSweetNotification(res?.['status']?.['message'] || 'Assuré non éligible à l\'hospitalisation', 'error');
          this.itemBeneficiare = null;
          this.beneficiaireAutOselect = null;
          this.authService.setActiveBeneficiaire({});
        }
      },
      error: (err: any) => {
        this.utilities.showSweetNotification(err, 'error');
        this.itemBeneficiare = null;
        this.beneficiaireAutOselect = null;
        this.authService.setActiveBeneficiaire({});
      },
    });
  }



  selectedChangeValue(event: any) {
    this.indiceTab = event || 1;
  }

  openDemandeModal() {
    this.itemBeneficiare = null;
    this.beneficiaireAutOselect = null;
    this.authService.setActiveBeneficiaire({});
    this.showDemandeModal = true;
    document.body.style.overflow = 'hidden';
    setTimeout(() => this.demandeComp?.resetForm(), 0);
  }

  closeDemandeModal() {
    this.showDemandeModal = false;
    document.body.style.overflow = '';
  }





}
